module.exports = __webpack_public_path__ + "img/Anniversary35D.d828d7dd.png";